import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../assets/about.svg";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              GET TO <span className="light-brown">KNOW </span> ME
            </h1>
            <Aboutcard />
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "120px", paddingBottom: "50px" }}
            className="about-img"
          >
            <img src={laptopImg} alt="about" className="img-fluid" />
          </Col>
        </Row>
        <h1 className="project-heading">
          Programming <strong className="light-brown">Languages </strong>
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          <Techstack iconName="devicon-javascript-plain" />
          <Techstack iconName="devicon-typescript-plain " />
          <Techstack iconName="devicon-java-plain-wordmark" />
          <Techstack iconName="devicon-cplusplus-line-wordmark" />
          <Techstack iconName="devicon-python-plain-wordmark" />
          <Techstack iconName="devicon-bash-plain" />
        </Row>
        <h1 className="project-heading">
          Mastered <strong className="light-brown">Frameworks </strong>
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          <Techstack iconName="devicon-nodejs-plain-wordmark" />
          <Techstack iconName="devicon-nestjs-plain-wordmark" />
          <Techstack iconName="cib-spring" />
        </Row>
        <h1 className="project-heading">
          Other <strong className="light-brown">Skills </strong>
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          <Techstack iconName="devicon-git-plain-wordmark" />
          <Techstack iconName="devicon-docker-plain-wordmark" />
          <Techstack iconName="cib-amazon-aws " />
          <Techstack iconName="devicon-postgresql-plain-wordmark" />
          <Techstack iconName="devicon-oracle-original" />
          <Techstack iconName="devicon-mongodb-plain-wordmark" />
          <Techstack iconName="devicon-redis-plain-wordmark" />
        </Row>
        <h1 className="project-heading">
          Currently <strong className="light-brown">Learning</strong>
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          <Techstack iconName="devicon-react-original-wordmark" />
          <Techstack iconName="devicon-heroku-original-wordmark" />
          <Techstack iconName="devicon-googlecloud-plain-wordmark" />
        </Row>
        <h1 className="project-heading">
          <strong className="light-brown">Tools</strong> I use
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          <Techstack iconName="devicon-ubuntu-plain-wordmark" />
          <Techstack iconName="devicon-vim-plain" />
          <Techstack iconName="devicon-github-original-wordmark" />
          <Techstack iconName="devicon-webstorm-plain-wordmark" />
          <Techstack iconName="devicon-slack-plain-wordmark" />
        </Row>
        <Github />
      </Container>
    </Container>
  );
}

export default About;
